import { render, staticRenderFns } from "./informationSee.vue?vue&type=template&id=4b0b77ba&scoped=true"
import script from "./informationSee.vue?vue&type=script&lang=js"
export * from "./informationSee.vue?vue&type=script&lang=js"
import style0 from "./informationSee.vue?vue&type=style&index=0&id=4b0b77ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b77ba",
  null
  
)

export default component.exports